<div class="relative w-full h-full">
  <!-- Basemap Switcher Widget -->
  <div class="absolute top-1.5 right-2 z-20">
    <div
      class="inline-flex rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800"
    >
      <!-- Satellite Option -->
      <label
        class="px-3 py-1 cursor-pointer text-sm font-medium hover:bg-gray-100 dark:hover:bg-gray-700 rounded-r-lg flex items-center gap-1 border-l border-gray-200 dark:border-gray-700 dark:text-white"
      >
        <input
          type="radio"
          name="basemap"
          value="satellite"
          class="hidden"
          [checked]="currentBaseMap === 'satellite'"
          (change)="switchBasemap('satellite')"
        />
        <span [class.text-blue-600]="currentBaseMap === 'satellite'"
          >Satellite</span
        >
      </label>
      <!-- Default Map Option -->
      <label
        class="px-3 py-1 cursor-pointer text-sm font-medium hover:bg-gray-100 dark:hover:bg-gray-700 rounded-l-lg flex items-center gap-1 dark:text-white"
      >
        <input
          type="radio"
          name="basemap"
          value="normal"
          class="hidden"
          [checked]="currentBaseMap === 'normal'"
          (change)="switchBasemap('normal')"
        />
        <span [class.text-blue-600]="currentBaseMap === 'normal'"
          >Standard</span
        >
      </label>
    </div>
  </div>
  <!-- Map container -->
  <div id="map" class="w-full h-full"></div>
</div>
